import { cloneDeep, get, merge } from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getAppVariable<T = any>(key: string, defaultValue?: T): T {

  let partnerConfig;
  let partnerConfigJSON;

  if (process.env.NUXT_ENV_IS_NEXT_ENVIRONMENT === 'true') {
    partnerConfig = window.partnerConfig;
  }
  else {
    if (process.env['NUXT_ENV_PARTNER_CONFIG_JSON'] === undefined) {
      throw new ReferenceError('The "NUXT_ENV_PARTNER_CONFIG_JSON" environment variable must be defined')
    }

    if (process.env['NUXT_ENV_PARTNER_CONFIG_JSON'] === '') {
      throw new ReferenceError('The "NUXT_ENV_PARTNER_CONFIG_JSON" environment variable must be a raw JSON string')
    }

    if (partnerConfigJSON === undefined || partnerConfigJSON === null) {
      partnerConfigJSON = process.env.NUXT_ENV_PARTNER_CONFIG_JSON;
    }

    try {
      partnerConfig = JSON.parse(partnerConfigJSON);
    }

    catch (error) {
      throw new Error('The "NUXT_ENV_PARTNER_CONFIG_JSON" environment variable is set but not parsable as JSON')
    }
  }

  if (window.partnerConfigOverrides !== undefined) {
    partnerConfig = merge(cloneDeep(partnerConfig), cloneDeep(window.partnerConfigOverrides));
  }

  const variable = cloneDeep(get(partnerConfig, key))

  if (variable === undefined) {
    // WL-4568 Temporary solution
    console.warn(`Missing '${key}' in partner config object`);
    // @ts-expect-error - default value could be undefined and the return type does not handle this.
    return defaultValue;
  }

  return variable;
}
